import { render, staticRenderFns } from "./VenueMigration.vue?vue&type=template&id=4d983350"
import script from "./VenueMigration.vue?vue&type=script&lang=ts"
export * from "./VenueMigration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports